export default __webpack_public_path__ + "static/media/logo.d2452a01.svg";